<script setup lang="ts">
import { ref, getCurrentInstance } from 'vue';
import AuthLayout from '../components/AuthLayout.vue';
import { Button, Input } from '../components/ui';
import { useAuthProvidersStore } from '../stores/authProviders';
import { graphqlQuery, AUTH_PROVIDERS_QUERY, type AuthProvidersResponse } from '../graphql';
import { errorToast } from '../services/toasts';

const instance = getCurrentInstance();
const router = instance?.proxy?.$router;
const queryEmail = instance?.proxy?.$route?.query.email;
const authProvidersStore = useAuthProvidersStore();

const email = ref(typeof queryEmail === 'string' ? queryEmail : '');
const emailError = ref('');
const loading = ref(false);

async function handleSubmit() {
  emailError.value = '';

  if (!email.value) {
    emailError.value = 'Enter a valid email.';
    return;
  }

  loading.value = true;

  try {
    const response = await graphqlQuery<AuthProvidersResponse>(AUTH_PROVIDERS_QUERY, { email: email.value });

    authProvidersStore.setEmail(email.value);
    authProvidersStore.setAuthProviders(response.authProviders);

    router?.push('/users/sign_in_continue');
  } catch (error) {
    const message = error instanceof Error ? error.message : 'An error occurred';
    errorToast(message);
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <AuthLayout title="Welcome">
    <form @submit.prevent="handleSubmit">
      <Input
        id="sign-in-email"
        v-model="email"
        type="email"
        label="Email"
        placeholder="Email"
        autocomplete="email"
        :error="emailError"
      />

      <div class="mt-form-gap">
        <Button type="submit" variant="primary" size="lg" :loading="loading" :disabled="loading"> Continue </Button>
      </div>
    </form>
  </AuthLayout>
</template>
